/**
 * Las empresas que el selector de «Dar acceso» y «Mover de empresa» ofrece: todas menos las archivadas (demo
 * o no: una archivada no recibe accesos ni mudanzas). Las suspendidas siguen: es lo que se ofrecía hoy.
 */
export function empresasElegibles<
  T extends { id: string; name: string; archivedAt?: string | null },
>(empresas: T[]): Array<{ id: string; name: string }> {
  return empresas.filter((t) => !t.archivedAt).map((t) => ({ id: t.id, name: t.name }));
}
